export default __webpack_public_path__ + "static/media/cases7.0c243452.jpg";